// Contract Concept Middleware

import { ErrorType } from '../../models/HttpError';
import { AppThunkAction } from '../reducers';
import { Contract } from '../../models/Entities/Contracts/Contract';
import { ContractConcept } from '../../models/Entities/Contracts/ContractConcept';
import { NewContractConcept } from '../../models/Entities/Contracts/NewContractConcept';
import { Concept } from '../../models/Entities/Contracts/Concept';

// services
import * as Services from '../../services/ContractConcept.Services';
import * as ConceptConceptsServices from '../../services/ContractConceptConcept.Services';
import * as PaymentScheduleServices from '../../services/ContractConceptPaymentSchedule.Services';

// actions
import * as Actions from '../actions';
import { NewContractConceptConcept } from '../../models/Entities/Contracts/NewContractConceptConcept';
import { NewContractConceptPaymentSchedule } from '../../models/Entities/Contracts/NewContractConceptPaymentSchedule';
import { ContractConceptConcept } from '../../models/Entities/Contracts/ContractConceptConcept';
import { ContractConceptPaymentSchedule } from '../../models/Entities/Contracts/ContractConceptPaymentSchedule';
import { ContractAddendum } from '../../models/Entities/Contracts/ContractAddendum';


type KnownAction =
    | Actions.ContractConcepts.ContractConcept_GetAllBycontractId_Request_Action
    | Actions.ContractConcepts.ContractConcept_GetAllBycontractId_Receive_Action
    | Actions.ContractConcepts.ContractConcept_GetAllBycontractId_Fail_Action
    | Actions.ContractConcepts.ContractConcept_GetAllByAddendumId_Request_Action
    | Actions.ContractConcepts.ContractConcept_GetAllByAddendumId_Receive_Action
    | Actions.ContractConcepts.ContractConcept_GetAllByAddendumId_Fail_Action
    | Actions.ContractConcepts.ContractConcept_UpdateAllByContractId_Request_Action
    | Actions.ContractConcepts.ContractConcept_UpdateAllByContractId_Receive_Action
    | Actions.ContractConcepts.ContractConcept_UpdateAllByContractId_Fail_Action
    | Actions.ContractConcepts.ContractConcept_GetById_Request_Action
    | Actions.ContractConcepts.ContractConcept_GetById_Receive_Action
    | Actions.ContractConcepts.ContractConcept_GetById_Fail_Action
    | Actions.ContractConcepts.ContractConcept_Add_Request_Action
    | Actions.ContractConcepts.ContractConcept_Add_Receive_Action
    | Actions.ContractConcepts.ContractConcept_Add_Fail_Action
    | Actions.ContractConcepts.ContractConcept_Update_Request_Action
    | Actions.ContractConcepts.ContractConcept_Update_Receive_Action
    | Actions.ContractConcepts.ContractConcept_Update_Fail_Action
    | Actions.ContractConcepts.ContractConcept_Delete_Request_Action
    | Actions.ContractConcepts.ContractConcept_Delete_Receive_Action
    | Actions.ContractConcepts.ContractConcept_Delete_Fail_Action
    | Actions.ContractConcepts.ContractConcept_Set_Enabled_Request_Action
    | Actions.ContractConcepts.ContractConcept_Set_Enabled_Receive_Action
    | Actions.ContractConcepts.ContractConcept_Set_Enabled_Fail_Action
    | Actions.ContractConcepts.ContractConcept_Set_Approved_Request_Action
    | Actions.ContractConcepts.ContractConcept_Set_Approved_Receive_Action
    | Actions.ContractConcepts.ContractConcept_Set_Approved_Fail_Action
    | Actions.ContractConceptConcept.ContractConceptConcept_Delete_Request_Action
    | Actions.ContractConceptConcept.ContractConceptConcept_Delete_Receive_Action
    | Actions.ContractConceptConcept.ContractConceptConcept_Add_Receive_Action
    | Actions.ContractConceptPaymentsSchedule.ContractConceptPaymentSchedule_Delete_Receive_Action



export const actionCreators = {
    SetContractConceptEnabled:
        (contractConceptId: number, enabled: boolean, contractId: number, contractAddendumId: number): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {

            var state = getState();
            var token: string;

            if(state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'CONTRACTCONCEPT_SET_ENABLED_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                })
                return;
            } else {
                token = state.oidc.user.access_token;
            };

            dispatch({
                type: 'CONTRACTCONCEPT_SET_ENABLED_REQUEST_ACTION',
                contractConceptId: contractConceptId,
                enabled: enabled
            });

            Services.SetContractConceptEnabled(contractConceptId, enabled, token)
            .then(() => {
                dispatch({
                    type: 'CONTRACTCONCEPT_SET_ENABLED_RECEIVE_ACTION',
                    contractConceptId: contractConceptId,
                    enabled: enabled,
                    contractId: contractId,
                    contractAddendumId: contractAddendumId
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: 'CONTRACTCONCEPT_SET_ENABLED_FAIL_ACTION',
                    error: error
                })
            );

    },
    SetContractConceptApproved:
        (contractConceptId: number, approved: boolean, contractId: number, contractAddendumId: number): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {

            var state = getState();
            var token: string;

            if(state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'CONTRACTCONCEPT_SET_APPROVED_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                })
                return;
            } else {
                token = state.oidc.user.access_token;
            };

            dispatch({
                type: 'CONTRACTCONCEPT_SET_APPROVED_REQUEST_ACTION',
                contractConceptId: contractConceptId,
                approved: approved
            });

            Services.SetContractConceptApproved(contractConceptId, approved, token)
            .then(() => {
                dispatch({
                    type: 'CONTRACTCONCEPT_SET_APPROVED_RECEIVE_ACTION',
                    contractConceptId: contractConceptId,
                    approved: approved,
                    contractId: contractId,
                    contractAddendumId: contractAddendumId
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: 'CONTRACTCONCEPT_SET_APPROVED_FAIL_ACTION',
                    error: error
                })
            );

    },
    GetAllContractsConcept:
        (contractId: number, referralDate: Date | undefined): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            
            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'CONTRACTCONCEPT_GET_ALL_BY_CONTRACTID_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }
            if (state.Contract?.list?.find((contract: Contract) => contract.id === contractId)?.concepts?.length === 0 ) {
                dispatch({
                    type: 'CONTRACTCONCEPT_GET_ALL_BY_CONTRACTID_REQUEST_ACTION',
                    contractId: contractId
                });
                Services.GetContractsConcept(contractId, referralDate, token)
                    .then((contractConcepts: ContractConcept[]) => {
                        dispatch({
                            type: 'CONTRACTCONCEPT_GET_ALL_BY_CONTRACTID_RECEIVE_ACTION',
                            contractConcepts: contractConcepts,
                            contractId: contractId
                        });
                    })
                    .catch((error: ErrorType) =>
                        dispatch({
                            type: 'CONTRACTCONCEPT_GET_ALL_BY_CONTRACTID_FAIL_ACTION',
                            error: error
                        })
                    );
            } else {
                dispatch({
                    type: 'CONTRACTCONCEPT_UPDATE_ALL_BY_CONTRACTID_REQUEST_ACTION',
                    contractId: contractId
                });

                Services.GetContractsConcept(contractId, referralDate, token)
                    .then((contractConcepts: ContractConcept[]) => {
                        dispatch({
                            type: 'CONTRACTCONCEPT_UPDATE_ALL_BY_CONTRACTID_RECEIVE_ACTION',
                            contractConcepts: contractConcepts,
                            contractId: contractId
                        });
                    })
                    .catch((error: ErrorType) =>
                        dispatch({
                            type: 'CONTRACTCONCEPT_GET_ALL_BY_CONTRACTID_FAIL_ACTION',
                            error: error
                        })
                    );
            }
        },
    GetAllContractsConceptByAddendum:
        (contractId: number, addendumId: number): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            
            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_FAIL_ACTION',
                    contractId: contractId,
                    addendumId: addendumId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_REQUEST_ACTION',
                contractId: contractId,
                addendumId: addendumId
            });

            Services.GetContractConceptsByAddendumId(addendumId, token)
            .then((contractConcepts: ContractConcept[]) => {
                dispatch({
                    type: 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_RECEIVE_ACTION',
                    contractConcepts: contractConcepts,
                    contractId: contractId,
                    addendumId: addendumId
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_FAIL_ACTION',
                    contractId: contractId,
                    addendumId: addendumId,
                    error: error
                })
            );
        },
    GetContractConceptById:
        (id: number): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            
            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'CONTRACTCONCEPT_GET_BY_ID_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            if(
                (state.ContractConcept?.list || []).find((contractConcept: ContractConcept) => contractConcept.id === id)) return;

            dispatch({
                type: 'CONTRACTCONCEPT_GET_BY_ID_REQUEST_ACTION',
                contractConceptId: id
            });

            Services.GetContractConceptById(id, token)
            .then((contractConcept: ContractConcept) => {
                dispatch({
                    type: 'CONTRACTCONCEPT_GET_BY_ID_RECEIVE_ACTION',
                    contractConcept: contractConcept
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: 'CONTRACTCONCEPT_GET_BY_ID_FAIL_ACTION',
                    error: error
                })
            );

        },
    AddContractConcept:
        (contractAddendumId: number, newContractConcept: NewContractConcept): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            
        var state = getState();
        var token: string;

        if (state.oidc?.user?.access_token === undefined) {
            dispatch({
                type: 'CONTRACTCONCEPT_ADD_FAIL_ACTION',
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        } else {
            token = state.oidc.user.access_token;
        }

        dispatch({
            type: 'CONTRACTCONCEPT_ADD_REQUEST_ACTION',
            newContractConcept: newContractConcept
        });

        Services.CreateConcept(newContractConcept.concept, token).then((concept: Concept) => {
            // set conceptID
            newContractConcept.conceptId = concept.id;
            Services.CreateContractConcept(newContractConcept, token)
            .then((contractConcept: ContractConcept) => {

                // // delete old concepts 
                // if (newContractConcept.concepts !== undefined) {
                //     newContractConcept.concepts.forEach((ItemConcept: ContractConceptConcept | NewContractConceptConcept) => {
                //         if((ItemConcept as ContractConceptConcept).id !== undefined)
                //         {
                //             var currentConcept = (ItemConcept as ContractConceptConcept);
                //             ConceptConceptsServices.DeleteContractConceptConcept(currentConcept.id, token);
                //             dispatch({
                //                 type: 'CONTRACTCONCEPTCONCEPT_DELETE_RECEIVE_ACTION',
                //                 contractConceptConceptId: currentConcept.id,
                //                 contractConceptId: contractConcept.id,
                //                 contractId: contractConcept.contractId
                //             });
                //         }
                        
                //     });
                // }

                // save concepts
                (newContractConcept.concepts || []).filter((concept: NewContractConceptConcept) => concept.isSelect)?.forEach((concept: NewContractConceptConcept) => {
                    concept.contractConceptId = contractConcept.id;
                    ConceptConceptsServices.CreateContractConceptConcept(concept, token).then((contractConceptConcept: ContractConceptConcept) => {
                    
                        dispatch({
                            type: 'CONTRACTCONCEPTCONCEPT_ADD_RECEIVE_ACTION',
                            /* The reducer locates the concept through contractConceptId. */
                            contractConceptConcept: { ...contractConceptConcept, contractConceptId: contractConceptConcept.contractConceptId ?? contractConcept.id },
                            contractAddendumId: contractAddendumId,
                            contractId: contractConcept.contractId
                        });

                    })
                    .catch((error: any) => console.log(error));
                });

                // //save payment schedule
                // newContractConcept.paymentSchedule?.forEach((paymentSchedule: NewContractConceptPaymentSchedule) => {
                //     paymentSchedule.contractConceptId = contractConcept.id;
                //     PaymentScheduleServices.CreateContractConceptPaymentSchedule(paymentSchedule, token);
                // });

                dispatch({
                    type: 'CONTRACTCONCEPT_ADD_RECEIVE_ACTION',
                    contractConcept: contractConcept
                });
            })
            .catch((error: any) => {
                console.log(error);
                dispatch({
                    type: 'CONTRACTCONCEPT_ADD_FAIL_ACTION',
                    error: error
                });
            });
        })
        .catch((error: ErrorType) =>
            dispatch({
                type: 'CONTRACTCONCEPT_ADD_FAIL_ACTION',
                error: error
            })
        );
    },
    UpdateContractConcept:
        (updatedContractConcept: ContractConcept): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
            
            var state = getState();
            var token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'CONTRACTCONCEPT_UPDATE_FAIL_ACTION',
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'CONTRACTCONCEPT_UPDATE_REQUEST_ACTION',
                contractConcept: updatedContractConcept
            });

            Services.UpdateConcept(updatedContractConcept.concept, token).then((concept: Concept) => {
                updatedContractConcept.conceptId = concept.id;
            });

            Services.UpdateContractConcept(updatedContractConcept, token)
            .then((contractConcept: ContractConcept) => {

                /*
                 * Associated concepts: write only what actually changed. Creating an
                 * association that already exists duplicates it (or fails), and deleting
                 * one that never existed fired a failing request for every unchecked
                 * concept on every save. Both used to run without a catch, so those
                 * failures never reached the store and the checkboxes drifted. An empty
                 * collection means the form did not touch them, and is skipped.
                 */
                const submittedConcepts = updatedContractConcept.concepts || [];
                if (submittedConcepts.length > 0) {
                    const targetConceptId = updatedContractConcept.id ?? contractConcept.id;
                    const targetContractId = updatedContractConcept.contractId ?? contractConcept.contractId;
                    const targetAddendumId = updatedContractConcept.contractAddendumId ?? contractConcept.contractAddendumId;

                    const storedConcepts: ContractConceptConcept[] = getState().Contract?.list
                        ?.find((item: Contract) => item.id === targetContractId)?.addendums
                        ?.find((item: ContractAddendum) => item.id === targetAddendumId)?.concepts
                        ?.find((item: ContractConcept) => item.id === targetConceptId)?.concepts || [];

                    const storedRelatedIds = storedConcepts.map((concept: ContractConceptConcept) => concept.relatedContractConceptId);
                    const selectedRelatedIds = submittedConcepts
                        .filter((concept: NewContractConceptConcept | ContractConceptConcept) => concept.isSelect)
                        .map((concept: NewContractConceptConcept | ContractConceptConcept) => concept.relatedContractConceptId);

                    selectedRelatedIds
                        .filter((relatedContractConceptId: number) => !storedRelatedIds.includes(relatedContractConceptId))
                        .forEach((relatedContractConceptId: number) => {
                            ConceptConceptsServices.CreateContractConceptConcept({
                                contractConceptId: targetConceptId,
                                relatedContractConceptId: relatedContractConceptId,
                                isSelect: true,
                                applyOnlyOnOwnerAmount: submittedConcepts.find(
                                    (concept: NewContractConceptConcept | ContractConceptConcept) => concept.relatedContractConceptId === relatedContractConceptId
                                )?.applyOnlyOnOwnerAmount === true
                            }, token)
                            .then((contractConceptConcept: ContractConceptConcept) => {
                                dispatch({
                                    type: 'CONTRACTCONCEPTCONCEPT_ADD_RECEIVE_ACTION',
                                    /* The reducer locates the concept through contractConceptId. */
                                    contractConceptConcept: { ...contractConceptConcept, contractConceptId: contractConceptConcept.contractConceptId ?? targetConceptId },
                                    contractAddendumId: targetAddendumId,
                                    contractId: targetContractId
                                });
                            })
                            .catch((error: any) => console.log(error));
                        });

                    /*
                     * An association that is kept can still have changed its settings, and
                     * the create/delete diff above never looks at it, so it is updated here.
                     */
                    storedConcepts
                        .filter((storedConcept: ContractConceptConcept) => selectedRelatedIds.includes(storedConcept.relatedContractConceptId))
                        .forEach((storedConcept: ContractConceptConcept) => {
                            const submittedConcept = submittedConcepts.find(
                                (concept: NewContractConceptConcept | ContractConceptConcept) => concept.relatedContractConceptId === storedConcept.relatedContractConceptId
                            );
                            const applyOnlyOnOwnerAmount = submittedConcept?.applyOnlyOnOwnerAmount === true;

                            if (applyOnlyOnOwnerAmount === (storedConcept.applyOnlyOnOwnerAmount === true)) return;

                            ConceptConceptsServices.UpdateContractConceptConcept({
                                id: storedConcept.id,
                                contractConceptId: storedConcept.contractConceptId ?? targetConceptId,
                                relatedContractConceptId: storedConcept.relatedContractConceptId,
                                isSelect: true,
                                applyOnlyOnOwnerAmount: applyOnlyOnOwnerAmount
                            } as ContractConceptConcept, token)
                            .then((contractConceptConcept: ContractConceptConcept) => {
                                dispatch({
                                    /* The add reducer replaces the association by its related id,
                                     * which is exactly the merge this update needs. */
                                    type: 'CONTRACTCONCEPTCONCEPT_ADD_RECEIVE_ACTION',
                                    contractConceptConcept: { ...contractConceptConcept, contractConceptId: contractConceptConcept.contractConceptId ?? targetConceptId },
                                    contractAddendumId: targetAddendumId,
                                    contractId: targetContractId
                                });
                            })
                            .catch((error: any) => console.log(error));
                        });

                    storedRelatedIds
                        .filter((relatedContractConceptId: number) => !selectedRelatedIds.includes(relatedContractConceptId))
                        .forEach((relatedContractConceptId: number) => {
                            ConceptConceptsServices.DeleteContractConceptConceptByRelationship(targetConceptId, relatedContractConceptId, token)
                            .then(() => {
                                dispatch({
                                    type: 'CONTRACTCONCEPTCONCEPT_DELETE_RECEIVE_ACTION',
                                    relatedContractConceptId: relatedContractConceptId,
                                    contractConceptId: targetConceptId,
                                    contractAddendumId: targetAddendumId,
                                    contractId: targetContractId
                                });
                            })
                            .catch((error: any) => console.log(error));
                        });
                }

                dispatch({
                    type: 'CONTRACTCONCEPT_UPDATE_RECEIVE_ACTION',
                    contractConcept: contractConcept
                });
            })
            .catch(error => console.log(error));
        },
    DeleteContractConcept:
        (id: number, contractId: number, addendumId: number): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {
        
        var state = getState();
        var token: string;

        if (state.oidc?.user?.access_token === undefined) {
            dispatch({
                type: 'CONTRACTCONCEPT_DELETE_FAIL_ACTION',
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                }
            });
            return;
        } else {
            token = state.oidc.user.access_token;
        }

        dispatch({
            type: 'CONTRACTCONCEPT_DELETE_REQUEST_ACTION',
            contractConceptId: id,
            contractId: contractId
        });

        Services.DeleteContractConcept(id, token)
            .then((result: boolean) => {
                dispatch({
                    type: 'CONTRACTCONCEPT_DELETE_RECEIVE_ACTION',
                    contractConceptId: id,
                    addendumId: addendumId,
                    contractId: contractId
                });
            })
            .catch((error: ErrorType) =>
                dispatch({
                    type: 'CONTRACTCONCEPT_DELETE_FAIL_ACTION',
                    error: error
                })
            );

        },

    CloneContractConcept:
        (contractId: number, addendumId: number, contractConceptId: number): AppThunkAction<KnownAction> =>
        async (dispatch, getState) => {

            const state = getState();
            let token: string;

            if (state.oidc?.user?.access_token === undefined) {
                dispatch({
                    type: 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_FAIL_ACTION',
                    contractId,
                    addendumId,
                    error: {
                        ErrorCode: 401,
                        ErrorMessage: 'Not authorized',
                        Errors: []
                    }
                });
                return;
            } else {
                token = state.oidc.user.access_token;
            }

            dispatch({
                type: 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_REQUEST_ACTION',
                contractId,
                addendumId
            });

            Services.CloneContractConcept(contractConceptId, token)
                .then(() => Services.GetContractConceptsByAddendumId(addendumId, token))
                .then((contractConcepts: ContractConcept[]) => {
                    dispatch({
                        type: 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_RECEIVE_ACTION',
                        contractConcepts,
                        contractId,
                        addendumId
                    });
                })
                .catch((error: ErrorType) =>
                    dispatch({
                        type: 'CONTRACTCONCEPT_GET_ALL_BY_ADDENDUMID_FAIL_ACTION',
                        contractId,
                        addendumId,
                        error
                    })
                );
        }
};
